<form [formGroup]="formGroup">
  <div class="row mt-2">
    <div class="col">
      <div class="d-flex flex-wrap">
        @for (criteria of criteriaList; track $index; let i = $index) {
        <button
          type="button"
          [id]="criteria.name"
          (click)="toggleActive(criteria)"
          (customCriteriaClicked)="customClicked($event)"
          [disabled]="criteria.disabled"
          [class.btn-primary]="criteria.active"
          [class.btn-outline-primary]="!criteria.active"
          [class.btn-criteria-lg]="largeButtons"
          [class.btn-criteria]="!largeButtons"
          class="btn btn-sm mt-2 mb-3 md-0 me-4"
        >
          {{ criteria.title }}
        </button>
        @if (shouldAddLineBreak(i)) {
        <div class="break"></div>
        } }
      </div>
    </div>
  </div>
  @for (criteria of criteriaList; track $index) {
  <div>
    <div class="row">
      <div class="col" [class.mb-5]="criteria.customTemplate">
        @if (criteria.active) {
        <ng-container *ngTemplateOutlet="criteria.customTemplate ? criteria.customTemplate : defaultTemplate">
        </ng-container>
        <ng-template #defaultTemplate>
          @if (!criteria.customInputField) {
          <ama-ng-upp-multi-select-badges
            [formElementName]="criteria.name"
            [formElementLabel]="criteria.title"
            [formGroup]="formGroup"
            [placeholder]="criteria.placeholder"
            [numberOfBadges]="criteria.numberOfBadges!"
            [readonlyMode]="readonly"
            [badgeItems]="criteria.badgeItems"
            [notFoundText]="criteria.notFoundText"
            [tooltipText]="criteria.tooltip"
            [availableItems]="criteria.possibleValues ? criteria.possibleValues : []"
            [lookup]="readonly ? undefined : criteria.lookupOptions"
            [customPasteRegExp]="criteria.customPasteRegExp"
            [parent]="parent"
            (removeBadge)="onRemoveBadge($event, criteria)"
            [disableNewValues]="criteria.disableNewValues ? criteria.disableNewValues : false"
          >
          </ama-ng-upp-multi-select-badges>
          }
        </ng-template>
        }
      </div>
    </div>
  </div>
  }
</form>
